<!-- src/shared/components/TecladoVirtual.vue -->
<template>
    <div class="teclado-virtual" v-if="visivel">
        <div v-for="(linha, i) in teclas" :key="i" class="teclado-linha">
            <button v-for="tecla in linha" :key="tecla" type="button" class="teclado-tecla" @mousedown.prevent @click="$emit('tecla', tecla)">
                {{ tecla === ' ' ? 'espaço' : tecla }}
            </button>
        </div>
        <div class="teclado-linha">
            <button type="button" class="teclado-tecla teclado-acao" @mousedown.prevent @click="$emit('backspace')">⌫</button>
            <button type="button" class="teclado-tecla teclado-acao" @mousedown.prevent @click="$emit('limpar')">Limpar</button>
            <button type="button" class="teclado-tecla teclado-acao" @mousedown.prevent @click="$emit('fechar')">Fechar</button>
        </div>
    </div>
</template>

<script>
const LAYOUT_NUMERICO = [['1', '2', '3'], ['4', '5', '6'], ['7', '8', '9'], ['0']];
const LAYOUT_TEXTO = [
    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
    ['z', 'x', 'c', 'v', 'b', 'n', 'm'],
    ['á', 'é', 'í', 'ó', 'ú', 'ã', 'õ', 'ç'],
    ['@', '.', '-', '_', ' '],
];

export default {
    name: 'TecladoVirtual',
    props: {
        layout: { type: String, default: 'texto' },
        visivel: { type: Boolean, default: true },
    },
    emits: ['tecla', 'backspace', 'limpar', 'enter', 'fechar'],
    computed: {
        teclas() {
            return this.layout === 'numerico' ? LAYOUT_NUMERICO : LAYOUT_TEXTO;
        },
    },
};
</script>

<style scoped>
.teclado-virtual {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f2f2f2;
    padding: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    user-select: none;
}
.teclado-linha {
    display: flex;
    gap: 6px;
    justify-content: center;
    flex-wrap: wrap;
}
.teclado-tecla {
    min-width: 70px;
    min-height: 70px;
    font-size: 1.9rem;
    border: 1px solid #ccc;
    border-radius: 8px;
    background: #fff;
    cursor: pointer;
}
.teclado-tecla:active {
    background: #ddd;
}
.teclado-acao {
    min-width: 122px;
    font-size: 1.5rem;
}
</style>
